import { saveRecentlyViewed } from '@theme/lib-recently-viewed';

function persistRecentlyViewedProduct() {
  const node = document.getElementById('recently-viewed-product-data');
  if (!node) return;

  const productId = node.dataset.productId;
  if (!productId) return;

  saveRecentlyViewed({
    id: productId,
    title: node.dataset.productTitle || '',
    url: node.dataset.productUrl || '',
    image: node.dataset.productImage || '',
    price: node.dataset.productPrice || '',
  });

  document.dispatchEvent(new CustomEvent('recently-viewed:updated'));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', persistRecentlyViewedProduct);
} else {
  persistRecentlyViewedProduct();
}
